import { useOnboardingStore } from '../stores/onboardingStore';
import type { ShortcutId } from './shortcutCatalog';
import { shortcutIdForNodeType } from './shortcutCatalog';

export { SHORTCUTS, shortcutIdForNodeType, shortcutDisplay, formatShortcutKeys } from './shortcutCatalog';
export type { ShortcutId, ShortcutDef } from './shortcutCatalog';
export { TUTORIAL_STEPS } from './tutorialSteps';
export type { TutorialStep } from './tutorialSteps';
export { useOnboardingStore } from '../stores/onboardingStore';

/** Call from click / drag / context-menu paths that duplicate a shortcut. */
export function usedViaPointer(id: ShortcutId | null | undefined) {
  if (!id) return;
  useOnboardingStore.getState().reportPointer(id);
}

/** Call after a keyboard shortcut actually runs. */
export function usedViaKeyboard(id: ShortcutId | null | undefined) {
  if (!id) return;
  useOnboardingStore.getState().reportKeyboard(id);
}

export function usedViaPointerNodeType(type: string) {
  usedViaPointer(shortcutIdForNodeType(type));
}

export function usedViaKeyboardNodeType(type: string) {
  usedViaKeyboard(shortcutIdForNodeType(type));
}
